import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { Product } from '../../../types/graphql'
import { GET_DEPRECATED_FEATURED_PRODUCT_V2 } from '../../graphql/queries/GET_DEPRECATED_FEATURED_PRODUCT_V2'

type UseFetchFeaturedProductDataOpts = {
  color: string | undefined
  fit: string
  productGroupHandle: string
  skip: boolean
}

/**
 * @deprecated Leverage queries specific to your needs with catalog data. Don't use this shared giant Zidi data query.
 */
export const useFetchDeprecatedFeaturedProductData = ({
  color,
  fit,
  productGroupHandle,
  skip,
}: UseFetchFeaturedProductDataOpts) => {
  const { data, loading, previousData } = useQuery<{ productGroup: { featuredProduct: Product } }>(
    GET_DEPRECATED_FEATURED_PRODUCT_V2,
    {
      variables: { color, fit, productGroupHandle },
      skip,
    }
  )

  const featuredProduct = useMemo(() => {
    return loading
      ? previousData?.productGroup?.featuredProduct
      : data?.productGroup?.featuredProduct
  }, [data, loading, previousData])

  return {
    featuredProduct,
  }
}
